import React from "react"
import EventColorKey from "./EventColorKey"
import SessionStatusKey from "./SessionStatusKey"

const LegendWrapper = () => {
  return (
    <div className="d-flex gap-2 mt-4">
      <EventColorKey />
      <SessionStatusKey />
    </div>
  )
}

export default LegendWrapper
